import { TextArea } from 'alkali'
import TextInputControl from './TextInputControl'

export default TextArea('.form-control', {
	inputEvents: TextInputControl.CHANGE_EVENTS,
})
